export function createMerchantOrderAcceptanceClient(transport) {
    return {
        /**
         * POST /internal/v1/events/order-placed
         *
         * Requires scope: order-acceptance:ingest
         */
        ingestOrderPlaced(body, options) {
            return transport.request({
                method: "POST",
                path: "/internal/v1/events/order-placed",
                body,
                options,
            });
        },
        /**
         * One page of a merchant's orders awaiting a decision, soonest deadline first
         *
         * Requires scope: order-acceptance:read
         */
        listMerchantOrders(merchantId, limit, after, locationId, state, options) {
            return transport.request({
                method: "GET",
                path: `/v1/merchants/${encodeURIComponent(merchantId)}/orders`,
                query: { limit: limit, after: after, locationId: locationId, state: state },
                options,
            });
        },
        /**
         * GET /v1/orders/{orderId}/acceptance
         *
         * Requires scope: order-acceptance:read
         */
        getOrderAcceptance(orderId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/orders/${encodeURIComponent(orderId)}/acceptance`,
                options,
            });
        },
        /**
         * POST /v1/orders/{orderId}/accept
         *
         * Requires scope: order-acceptance:decide
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        acceptOrder(orderId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/orders/${encodeURIComponent(orderId)}/accept`,
                options,
            });
        },
        /**
         * POST /v1/orders/{orderId}/reject
         *
         * Requires scope: order-acceptance:decide
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        rejectOrder(orderId, options) {
            return transport.request({
                method: "POST",
                path: `/v1/orders/${encodeURIComponent(orderId)}/reject`,
                options,
            });
        },
        /**
         * POST /internal/v1/acceptances/expire-due
         *
         * Requires scope: order-acceptance:expire
         */
        expireDueAcceptances(options) {
            return transport.request({
                method: "POST",
                path: "/internal/v1/acceptances/expire-due",
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=merchant-order-acceptance.js.map